export const capitalizeString = (str: string): string => {
  const words = str.toLowerCase().split(' ')

  const capitalizedWords = words.map((w) => {
    const firstLetter = w.charAt(0).toUpperCase()
    const restOfWord = w.slice(1)

    return firstLetter + restOfWord
  })

  return capitalizedWords.join(' ')
}

export const capitalizeArray = (arr: string[]): string[] => arr.map((item) => capitalizeString(item))
